function Event ( parent ) {
	var WS_PORT = 8000;
	var WSS_PORT = 843;

	var self = this;

	self.parent = parent;

	self.eventConnectionRetryCount = 0;
	self.eventConnectionRetryDelay = 2000;
	self.eventModule = "EmployeeEventModule"
	self.eventDebug = false;
	self.eventNumber = 0;
	self.intervalId = -1;
	self.lastEventReceived;
	self.loadedEventListeners = false;
	self.maxEventConnectionRetries = 16;
	self.noPongCount = 0;
	self.pongReceived = true;
	self.qevtxhr = null;
	self.qlessPageId = new Date().getTime();
	self.responseIdx = 0;
	self.successfulLoad = false;
	self.ws = null;

	self.reqType = ko.computed(function () {
		if (self.parent.getQueryParam('polling') != null) {
			return self.parent.getQueryParam('polling').toUpperCase();
		}
		else if (bowser.msie){
			if (bowser.version < 8) {
				return null
			}
			return 'WEBSOCKET';
		}
		else if(window.XMLHttpRequest) {
			return 'LONGPOLL';
		}

		return null;
	});


	self.listener = {

		'eventURL' : function() {
			var rtn = '/qless/event/v1/employee?id=' + self.parent.event.qlessPageId;

			if (bowser.msie) {
				rtn += '&useScript=true';
			}

			return rtn;
		},

		'poll' : function() {
			try {
				qcal.event.conlog('LISTENING FOR EVENTS...');
				qcal.event.qevtxhr = qcal.event.createXMLHttpRequest();
				qcal.event.qevtxhr.open('GET', qcal.event.listener.eventURL(), true);

				qcal.event.qevtxhr.onreadystatechange = function() {
					if (typeof qcal.event.qevtxhr == 'undefined') {
						return;
					}

					if (qcal.event.qevtxhr.readyState == 3 && qcal.event.qevtxhr.status != 404) {
						qcal.event.listener.interactive(qcal.event.qevtxhr);
					}
					else if (qcal.event.qevtxhr.readyState == 4) {
						qcal.event.listener.process(qcal.event.qevtxhr);
					}
					else if (qcal.event.qevtxhr.readyState != 1 && qcal.event.qevtxhr.readyState != 2) {
						try {
							qcal.event.listener.logError('Unrecognized readyState: ' + qcal.event.qevtxhr.readyState + ', status: ' + qcal.event.qevtxhr.status);
						}
						catch (e) {}

						qcal.event.listener.reload();
					}
				};

				qcal.event.qevtxhr.onerror = function() {
					try {
						qcal.event.listener.logError('Onerror fired.  readyState: ' + qcal.event.qevtxhr.readyState + ', status: ' + qcal.event.qevtxhr.status);
					}
					catch (e) {}

					if (qcal.event.eventConnectionRetryCount++ < qcal.event.maxEventConnectionRetries) {
						setTimeout('qcal.event.listener.poll()', qcal.event.eventConnectionRetryDelay);
						qcal.event.eventConnectionRetryDelay *= 1.7;
					}
					else {
						try {
							qcal.event.listener.logError('Reloading page because onerror fired and too many connection retries.');
						}
						catch (e) {}

						qcal.event.listener.reload();
					}
				};

				try {
					qcal.event.qevtxhr.timeout = 120000;
					qcal.event.qevtxhr.ontimeout = function () {
						try {
							qcal.event.listener.logError('XHR Timeout');
						}
						catch (g) {}

						qcal.event.listener.reload();
					};
				}
				catch (f) {}

				qcal.event.qevtxhr.send(null);
			}
			catch (e) {
				try {
					qcal.event.listener.logError(e);
				}
				catch (e2) {}

				qcal.event.listener.reload();
			}
			qcal.event.conlog('CONNECTION ESTABLISHED');
		},

		'process' : function(transport) {
			try {
				if (transport != null) {
					if (transport.status == 200) {
						// if (eventDebug) {
						// 	alert('RESTARTING...');
						// }

						qcal.event.responseIdx = 0;
						qcal.event.successfulLoad = true;
						qcal.event.eventConnectionRetryCount = 0;
						qcal.event.conlog('PROCESS FINISHED. DOING NORMAL RELOAD');
						setTimeout('qcal.event.listener.poll()', 2000);
					}
					else {
						if (qcal.event.eventConnectionRetryCount++ < qcal.event.maxEventConnectionRetries) {
							//listener.logError('Transport status is ' + transport.status);
							setTimeout('qcal.event.listener.poll()', qcal.event.eventConnectionRetryDelay);
							qcal.event.eventConnectionRetryDelay *= 1.7;
						}
						else {
							try {
								qcal.event.listener.logError('Reloading page because transport status is ' + transport.status);
							}
							catch (e){}

							qcal.event.listener.reload();
						}
					}
				}
				else {
					try {
						qcal.event.listener.logError('Transport is null.  Reloading.');
					}
					catch (e) {}

					qcal.event.listener.reload();
				}
			}
			catch (e) {
				try {
					qcal.event.listener.logError(e);
				}
				catch (e2) {}

				if (qcal.event.eventConnectionRetryCount++ < qcal.event.maxEventConnectionRetries) {
					setTimeout('qcal.event.listener.poll()', 2000);
				}
				else {
					qcal.event.listener.reload();
				}
			}
		},

		'interactive' : function(transport) {
			try {
				var response = transport.responseText.substring(qcal.event.responseIdx);

				qcal.event.responseIdx = transport.responseText.length;
				qcal.event.listener.handleEvent(response);
				qcal.event.successfulLoad = true;
				qcal.event.eventConnectionRetryCount = 0;
				qcal.event.eventConnectionRetryDelay = 2000;
			}
			catch (e) {
				if (bowser.msie) {
					if (e.message == null || e.message.indexOf('SetVariable is not a function') == -1) {
						qcal.event.listener.logError(e);
					}
				}
			}
		},

		'handleEvent' : function(event) {
			var events = event.match(/\{([^}]+)\}/g),
				evt = null,
				i = 0;

			for (i=0; i<events.length; i++) {
				evt = events[i];
				qcal.event.conlog('Received event '+ evt);
				qcal.processEventResponse.apply(qcal, evt.substring( evt.indexOf(':') + 1, evt.indexOf('}') ).split(' ') );
			}

			qcal.event.eventNumber++;
			qcal.event.lastEventReceived = new Date();
		},

		'reload' : function() {
			var wait = (Math.random() * 60000) + 20000;

			qcal.event.conlog('RELOAD IN 20-60 s');
			setTimeout('document.location.reload()', wait);
		},

		'exceptionToString' : function(err) {
			var rtn = '{';

			if (typeof err != 'string') {
				for (var prop in err) {
					rtn += prop + '=[' + err[prop] + '], ';
				}
			}

			rtn += 'toString()=[' + err.toString() + ']}';

			return rtn;
		},

		'logError' : function(err) {
			try {
				var url = '/qless/api/v1/error?error=' + encodeURIComponent(qcal.event.listener.exceptionToString(err)),
					xhr = qcal.event.createXMLHttpRequest();

				xhr.open('GET', url, true);
				xhr.send(null);
			}
			catch (e) {}
		}

	};



	self.conlog = function (msg) {
		if (self.parent.getQueryParam('debug') === 'true') {
			console.log(msg);
		}
	};

	self.createXMLHttpRequest = function () {
		try {
			return new ActiveXObject('Msxml2.XMLHTTP');
		}
		catch(e) {
			try {
				return new ActiveXObject('Microsoft.XMLHTTP');
			}
			catch(e) {
				try {
					return new XMLHttpRequest();
				}
				catch(e) {
					return null;
				}

			}
		}
	};

	self.eventDiagnostic = function() {
		return 'Last event received: ' + self.lastEventReceived +
			', Event number: ' + self.eventNumber +
			', Event connection retry count: ' + self.eventConnectionRetryCount +
			', Event connection retry delay: ' + self.eventConnectionRetryDelay +
			', Successful load: ' + self.successfulLoad +
			', Page ID: ' + self.qlessPageId +
			', Transport status: ' + self.qevtxhr.status +
			', Transport ready state: ' + self.qevtxhr.readyState;
	};

	self.eventInit = function () {
		if (!bowser.msie && window.XMLHttpRequest) {
			self.listener.poll();
		}
		else if (bowser.msie && bowser.version >= 7) {
			self.iePoll();
		}
		else {
			alert('Sorry, we don\'t yet support your browser.  Please try Firefox.');
			window.location = 'http://www.mozilla.com';
		}

		if (window.console || (typeof console != 'undefined' && console.firebug)) {
			setInterval(function() {
				try {
					qcal.event.conlog('Checking xhr connection status: ' + qcal.event.qevtxhr.readyState + ' ' + qcal.event.qevtxhr.status);
				} catch (e){}
			}, 60000);
		}
	};

	self.iePoll = function () {
		var transferDoc = new ActiveXObject('htmlfile'),
			ifrDiv = transferDoc.createElement('div');

		transferDoc.open();
		transferDoc.write('<html><script>document.domain="' + document.domain + '";</script></html>');
		transferDoc.close();

		transferDoc.body.appendChild(ifrDiv);

		ifrDiv.innerHTML = '<iframe src="' + self.listener.eventURL() + '"></iframe>';

		transferDoc.parentWindow.p = function(event) {
			self.listener.handleEvent(event);
		};

		transferDoc.parentWindow.reconnect = function() {
			transferDoc = null;

			if (typeof CollectGarbage == 'function') {
				CollectGarbage();
			}

			setTimeout( 'iePoll();', 100);
		};

		// See http://www.issociate.de/board/post/483905/htmlfile_ActiveX_very_abscure_problem_(not_the_usual_disconnect.html
		setInterval( function () { var __x = (transferDoc && typeof transferDoc.parentWindow == 'object' ); }, 100);
	};

	self.wsProtocol = function (protocol) {
		return (protocol === 'https:') ? 'wss' : 'ws';
	}

	self.wsPort = function(protocol) {
		return (protocol === 'https:') ? WSS_PORT : WS_PORT;
	}

	self.start = function () {
		var ws = (document.location.protocol === 'https:') ? 'wss' :'ws';

		switch (self.reqType()) {
			case 'LONGPOLL' :
				self.conlog('Starting polling with Long Poll');
				self.eventInit(); // LONG POLL
				break;
			case 'WEBSOCKET' :
				var protocol = self.wsProtocol(document.location.protocol)
				var port = self.wsPort(document.location.protocol)
				self.conlog('Starting polling with Websockets');
				self.wsInit(protocol + '://' + document.domain + ':' + port + '/', self.eventModule)
				break;
		}
	};

	self.wsInit = function (url, module) {

		if (!self.loadedEventListeners) {
			// http://stackoverflow.com/questions/11795864/pagehide-event-on-imminent-tab-switching-in-mobile-safari-does-not-fire-when-run
			// Reset the noPongCount if the iPad screen is locked or an iOS browser is moved to the background/foreground.
			// http://stackoverflow.com/questions/1695376/msie-and-addeventlistener-problem-in-javascript
			if (window.addEventListener) {
				window.addEventListener("pagehide", function(evt) {
					qcal.event.noPongCount = 0;
				}, false);
				window.addEventListener("pageshow", function(evt) {
					qcal.event.noPongCount = 0;
				}, false);
			}
			self.loadedEventListeners = true;
		}

		self.ws = new WebSocket(url);

		self.ws.onopen = function() {
			var i = 0,
				multiAUCookie = null,
				singleAUCookie = jaaulde.utils.cookies.get('au');

			qcal.event.conlog('Web socket connection opened');

			qcal.event.ws.send("Module: " + module);

			if (singleAUCookie != null) {
				qcal.event.ws.send("AU: " + singleAUCookie);
			}
			else {
				i = 0;

				while (true) {
					multiAUCookie = jaaulde.utils.cookies.get('au__' + i);

					if (multiAUCookie != null) {
						qcal.event.ws.send("AU: " + multiAUCookie);
					}
					else {
						break;
					}

					i++;
				}
			}

			qcal.event.ws.send("PAGE: " + qcal.event.qlessPageId);

			qcal.event.pongReceived = true;
			qcal.event.intervalId = setInterval('qcal.event.websocketPing()', 5000);

			// Mobile browsers need a manual refresh in case browser had been backgrounded
			qcal.processEventResponse.apply(qcal, ['REFRESH']);

			// lz.embed.setCanvasAttribute('event' + eventNumber, "{\"event\":REFRESH}");
			// lz.embed.setCanvasAttribute('eventNumber', eventNumber);
			qcal.event.eventNumber++;
		};

		self.ws.onmessage = function(e) {
			if ('RELOAD' == e.data) {
				document.location.reload();
				return;
			}
			else if ('O' == e.data) {
				qcal.event.pongReceived = true;
				return;
			}
			else {
				qcal.processEventResponse.apply(qcal, e.data.substring( e.data.indexOf(':') + 1, e.data.indexOf('}') ).split(' ') );
			}

			qcal.event.eventNumber++;
			qcal.event.conlog('Received event ' + e.data);
			qcal.event.lastEventReceived = new Date();
		};

		self.ws.onclose = function() {
			qcal.event.conlog('Web socket connection closed.  Restarting it.');
			if (qcal.event.intervalId != -1) {
				clearInterval(qcal.event.intervalId);
				qcal.event.intervalId = -1;
			}
			setTimeout("qcal.event.wsInit('" + url + "', '" + module + "')", (Math.random() * 1000 + 1000));
		};

		self.ws.onerror = function(err) {
			qcal.event.conlog('Web socket connection error.  Reloading...');
			qcal.event.listener.logError(err);
			setTimeout("document.location.reload()", (Math.random() * 60000) + 10000);
		};
	};

	self.websocketPing = function () {
		if (!self.pongReceived) {
			if (++self.noPongCount < 3) {
				var err = 'No pong received from ping after 5 seconds.  Restarting websocket connection.';

				console.log(err);
				self.listener.logError(err);
				self.ws.close();
			}
			else {
				var err = 'No pong received from ping after 5 seconds for ' + self.noPongCount + ' consecutive attempts.  Reloading page.';

				console.log(err);
				self.listener.logError(err);
				setTimeout("document.location.reload()", (Math.random() * 60000) + 10000);
			}
			return;
		}
		self.pongReceived = false;
		self.ws.send('X');
	};

};